/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Change_PasswordInputs */

const en_page_title_change_password = /** @type {(inputs: Page_Title_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change password`)
};

const nl_page_title_change_password = /** @type {(inputs: Page_Title_Change_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord wijzigen`)
};

/**
* | output |
* | --- |
* | "Change password" |
*
* @param {Page_Title_Change_PasswordInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_change_password = /** @type {((inputs?: Page_Title_Change_PasswordInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Change_PasswordInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_change_password(inputs)
	return en_page_title_change_password(inputs)
});